import Vue from "vue"

/*
 * What the school has sent this family.
 *
 * The server has been writing these rows since the beginning - every one of
 * them addressed to a particular user, with a seen flag - and the only screen
 * in the panel that ever read a notification was the school's, through an
 * endpoint only a school may call. So a family had alert switches deciding
 * what got pushed to the app, and if they did not use the app, nothing they
 * had been told was visible to them anywhere.
 *
 * Held here rather than on a screen because two things need it: the bell in
 * the bar, which is on every page, and the list itself.
 */
export const notices = Vue.observable({
  items: [],
  unread: 0,
  loaded: false,
})

const count = () => {
  notices.unread = notices.items.filter(notice => !Number(notice.seen)).length
}

export default {
  /** Everything addressed to whoever is signed in, newest first. */
  load() {
    return axios
      .get("/notifications/list-all")
      .then(response => {
        notices.items = response.data.notifications || []
        notices.loaded = true
        count()

        return notices.items
      })
      .catch(error => {
        //the bell is not the place to report a failed request, and a screen
        //that wants to say so can catch this itself
        notices.loaded = true

        throw error
      })
  },
  /*
   * Marked read here as well as on the server, so the bell falls quiet on the
   * tap rather than a second later when the request comes back.
   */
  markSeen(id) {
    notices.items.forEach(notice => {
      if (notice.id === id) notice.seen = 1
    })
    count()

    return axios.post("/notifications/mark-as-seen", { id })
  },
  markAllSeen() {
    notices.items.forEach(notice => {
      notice.seen = 1
    })
    count()

    return axios.post("/notifications/mark-all-as-seen")
  },
  clearAll() {
    notices.items = []
    count()

    return axios.delete("/notifications/delete-all-notifications")
  },
  /** For the bell, which wants the number and not the reason for it. */
  quietly() {
    return this.load().catch(() => {})
  },
}
